import { OAuth2Client } from '@badgateway/oauth2-client';

import { postUserAuthTokenExchange } from '~/clients/jsonApi';

class Oauth2SSOProvider {
  configure = options => {
    this.options = options;
    this.handler = new OAuth2Client(this.options);
  };

  authorize = async connection => {
    const { redirectUri } = this.options;
    const scope = this.options.scope || connection;

    document.location = await this.handler.authorizationCode.getAuthorizeUri({
      redirectUri,
      scope,
    });
  };

  authenticate = async () => {
    const queryParams = new URL(document.location).searchParams;
    const code = queryParams.get('code');
    const { token } = await postUserAuthTokenExchange('oauth2', code);

    return token.access_token;
  };
}

export const provider = new Oauth2SSOProvider();
